// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"98":"b83dd15f","556":"800b07f8"}[chunkId] + ".css";
};